import React from 'react';

import { MDBDataTableV5 } from 'mdbreact';



export default function Basic(props) {
  let userAttributes;
  let i = 0;

  let datatable;
    [datatable] = React.useState('');
  
  if(props.venueList!==undefined){
    userAttributes = [];
    for (const key of Object.keys(props.venueList)) {
      let venueName = props.venueList[key]['VenueName'];
      let Address2 = props.venueList[key]['AddressLine2']!==""?props.venueList[key]['AddressLine2']+"\n\r":""
      userAttributes.push({
          venueName: props.venueList[key]['VenueName'],
          venueAddress: props.venueList[key]['AddressLine1']+"\n\r"+Address2+props.venueList[key]['City']+", "+props.venueList[key]['State']+" "+props.venueList[key]['PostalCode'],
          unitCount: props.venueList[key]['DailyReport']['UnitCount_GlobalWirelessPlusLocalWiredAccess']+props.venueList[key]['DailyReport']['UnitCount_LocalWirelessAccess']+props.venueList[key]['DailyReport']['UnitCount_GlobalWirelessRoaming'],
          policyCount: props.venueList[key]['DailyReport']['PolicyCount_GlobalWirelessPlusLocalWiredAccess']+props.venueList[key]['DailyReport']['PolicyCount_LocalWirelessAccess'],
          subscriberCount: props.venueList[key]['DailyReport']['PolicyCount_GlobalWirelessPlusLocalWiredAccess'],
          deviceCount: props.venueList[key]['DailyReport']['OnlineDeviceCount'],
          // status: props.venueList[key]['currentOperatorStatus']==="Operational"?<div className="active-circle"></div>:<div className="inactive-circle"></div>,
          clickEvent: ()=>props.modifyVenue(venueName, key)

        })
      i = i + 1;
      
    }
    
  }
  
    [datatable] = React.useState({
    columns: [
      
      {
        label: "Venue",
        field: 'venueName'
      },
      {
        label: "Address",
        field: 'venueAddress'
      },
      {
        label: "Unit Count",
        field: 'unitCount'
      },
      {
        label: "Policy Count",
        field: 'policyCount'
      },
      {
        label: 'Subscriber Count',
        field: 'subscriberCount',
      },
      {
        label: "Device Count",
        field: 'deviceCount',
      },
      // {
      //   label: "Status",
      //   field: 'status'
      // }
    ],
    rows: userAttributes
  });
  return <MDBDataTableV5 
            sortable={true}
            responsive 
            hover 
            data={datatable} 
            searchTop={true}
            searchBottom={false} 
            searchLabel="Filter" 
            paging={false}
            className="recentResidents"
            info={false}
            noRecordsFoundLabel="No Venues Found"
            sortRows={['activated']}
            />;
}